import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import { signOut } from '@/lib/auth';
import { toast } from 'sonner';

export function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/auth/login');
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleLogout}
      className="w-full justify-start px-2 gap-2 text-red-500 hover:text-red-600 hover:bg-red-50"
    >
      <LogOut className="h-4 w-4" />
      Sign Out
    </Button>
  );
}